import { useMutation } from '@tanstack/react-query';

import {
  ILoginResponse,
  MfaAuthenticateRequest,
  MfaAuthenticateResponse,
  MfaResendRequest,
  MfaResendResponse,
  MfaSkipRequest,
  MfaVerifyRequest
} from '../components/LoginModal/LoginModal.types';
import useAxios from '../hooks/useAxios';

import { EApiRoutes, getApiRouteOrMock } from './api.utils';

export default function useMfa() {
  const axios = useAxios();

  const authenticateMfa = useMutation(
    async (data: MfaAuthenticateRequest): Promise<MfaAuthenticateResponse> => {
      const response = await axios.post(
        getApiRouteOrMock(EApiRoutes.MFA_AUTHENTICATE),
        data,
        { withCredentials: true },
        { shouldClearSessionOnUnauthorized: false }
      );
      return response.data;
    }
  );

  const verifyMfa = useMutation(
    async (data: MfaVerifyRequest): Promise<ILoginResponse> => {
      const response = await axios.post(
        getApiRouteOrMock(EApiRoutes.MFA_VERIFY),
        data,
        { withCredentials: true },
        { shouldClearSessionOnUnauthorized: false }
      );
      return response.data;
    }
  );

  const skipMfa = useMutation(
    async (data: MfaSkipRequest): Promise<ILoginResponse> => {
      const response = await axios.post(
        getApiRouteOrMock(EApiRoutes.MFA_SKIP),
        data,
        { withCredentials: true },
        { shouldClearSessionOnUnauthorized: false }
      );

      return response.data;
    }
  );

  const resendMfa = useMutation(
    async (data: MfaResendRequest): Promise<MfaResendResponse> => {
      const response = await axios.post(
        getApiRouteOrMock(EApiRoutes.MFA_RESEND),
        data,
        { withCredentials: true },
        { shouldClearSessionOnUnauthorized: false }
      );
      return response.data;
    }
  );

  return {
    authenticateMfa,
    verifyMfa,
    skipMfa,
    resendMfa
  };
}


